
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Refonte de site web : comment éviter une perte de trafic SEO ?",
    description:
      "Une refonte mal gérée peut nuire à votre référencement. Découvrez les bonnes pratiques pour préserver et optimiser votre trafic SEO avec ALEO.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
